import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import { IDENTIFICATION_DOCUMENT_REMINDER_TYPE_KEYS } from "web_myplann/Reminders/Config/identificationDocumentReminderOffsets";
import type { ResourceKey } from "web_myplann/Reminders/Types/ReminderTypes";

// Templates come from BE (GET /v2/reminders/types); FE only owns the labels.
//
// The keys below are the *backing values* of the BE enums
// (api_myplann/moduleApi/Reminder/Enum/{Vehicle,Property,Portfolio}ReminderType.php).
// Do NOT use the generated `VehicleReminderType` / `PropertyReminderType` /
// `PortfolioReminderType` enums from Api.ts here — swagger emits the PHP *case
// names* ("Stk", "Custom"), not the values the API actually sends and accepts
// ("vehicle_stk", "portfolio_custom").
//
// Custom types are not listed: they are recognized via `isCustom` on the DTO,
// because each group has its own key (vehicle_custom / property_custom /
// portfolio_custom).
export const REMINDER_TEMPLATE_LABELS: Record<string, ResourceKey> = {
	vehicle_stk: Resources.Reminders.Templates.Vehicle.stk,
	vehicle_service: Resources.Reminders.Templates.Vehicle.service,
	vehicle_insurance: Resources.Reminders.Templates.Vehicle.insurance,
	vehicle_highway_vignette: Resources.Reminders.Templates.Vehicle.vignette,
	vehicle_emission_check: Resources.Reminders.Templates.Vehicle.emissions,
	property_chimney: Resources.Reminders.Templates.RealEstate.chimney,
	property_gas: Resources.Reminders.Templates.RealEstate.gas,
	property_electrical: Resources.Reminders.Templates.RealEstate.electrical,
	property_fire_extinguisher:
		Resources.Reminders.Templates.RealEstate.fireExtinguisher,
	property_tax: Resources.Reminders.Templates.RealEstate.propertyTax,
	// Vehicle.insurance is the shared "Pojistka" label - property insurance has
	// no separate entry in the dictionary (same as before the key fix).
	property_insurance: Resources.Reminders.Templates.Vehicle.insurance,
	[IDENTIFICATION_DOCUMENT_REMINDER_TYPE_KEYS.oneMonthBefore]:
		Resources.Reminders.Templates.IdentificationDocument.monthBefore,
	[IDENTIFICATION_DOCUMENT_REMINDER_TYPE_KEYS.threeMonthsBefore]:
		Resources.Reminders.Templates.IdentificationDocument.threeMonthsBefore,
	[IDENTIFICATION_DOCUMENT_REMINDER_TYPE_KEYS.onExpiry]:
		Resources.Reminders.Templates.IdentificationDocument.onExpiry,
};
